import { creatorLightTheme } from '@spotify-internal/encore-web';
import { defaultTheme, MODULE_THEMES } from '../features/ui/Theme';
export const getModuleBackgroundBottomColor = (mod) => {
    var _a, _b;
    if ((_a = mod.colors) === null || _a === void 0 ? void 0 : _a.gradientBottomColor) {
        return (_b = mod.colors) === null || _b === void 0 ? void 0 : _b.gradientBottomColor;
    }
    return undefined;
};
export const getModuleBackgroundColor = (mod) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const legacyCustomTheme = {
        ...defaultTheme,
        ...MODULE_THEMES[mod.themeName || mod.theme || ''],
    };
    if ((_a = mod.colors) === null || _a === void 0 ? void 0 : _a.backgroundColor) {
        return (_b = mod.colors) === null || _b === void 0 ? void 0 : _b.backgroundColor;
    }
    switch (mod === null || mod === void 0 ? void 0 : mod.contentType) {
        case 'faqLinksModule':
        case 'singleFeatureModule':
            return (_c = legacyCustomTheme === null || legacyCustomTheme === void 0 ? void 0 : legacyCustomTheme.box) === null || _c === void 0 ? void 0 : _c.background;
        case 'featuredContent3up': {
            if (mod.themeName === 'dark') {
                return creatorLightTheme.invertedDark.background.base;
            }
            return creatorLightTheme.base.background.base;
        }
        case 'headerModule':
            return mod.backgroundColor;
        case 'heroNarrativeCover':
            return (_d = mod.colors) === null || _d === void 0 ? void 0 : _d.backgroundColor;
        case 'videoModuleLongBody':
        case 'videoModule':
            return creatorLightTheme.invertedDark.background.base;
        case 'featuredContentModule':
            return (_e = legacyCustomTheme === null || legacyCustomTheme === void 0 ? void 0 : legacyCustomTheme.box) === null || _e === void 0 ? void 0 : _e.background;
        default:
            if (mod === null || mod === void 0 ? void 0 : mod.backgroundColor) {
                return mod.backgroundColor;
            }
            if (mod === null || mod === void 0 ? void 0 : mod.theme) {
                return (_f = creatorLightTheme[mod.theme === 'light' ? 'base' : 'invertedDark']) === null || _f === void 0 ? void 0 : _f.background.base;
            }
            if (mod === null || mod === void 0 ? void 0 : mod.themeName) {
                return (_g = legacyCustomTheme === null || legacyCustomTheme === void 0 ? void 0 : legacyCustomTheme.box) === null || _g === void 0 ? void 0 : _g.background;
            }
            return creatorLightTheme.invertedDark.background.base;
    }
};
export const getModuleTextColor = (mod) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const legacyCustomTheme = {
        ...defaultTheme,
        ...MODULE_THEMES[mod.themeName || mod.theme || ''],
    };
    if ((_a = mod.colors) === null || _a === void 0 ? void 0 : _a.textColor) {
        return (_b = mod.colors) === null || _b === void 0 ? void 0 : _b.textColor;
    }
    switch (mod === null || mod === void 0 ? void 0 : mod.contentType) {
        case 'faqLinksModule':
        case 'singleFeatureModule':
            return (_c = legacyCustomTheme === null || legacyCustomTheme === void 0 ? void 0 : legacyCustomTheme.box) === null || _c === void 0 ? void 0 : _c.text;
        case 'featuredContent3up': {
            if (mod.themeName === 'dark') {
                return creatorLightTheme.invertedDark.text.base;
            }
            return creatorLightTheme.base.text.base;
        }
        case 'headerModule':
            return mod.textColor;
        case 'heroNarrativeCover':
            return (_d = mod.colors) === null || _d === void 0 ? void 0 : _d.textColor;
        case 'videoModuleLongBody':
        case 'videoModule':
            return creatorLightTheme.invertedDark.text.base;
        case 'featuredContentModule':
            return (_e = legacyCustomTheme === null || legacyCustomTheme === void 0 ? void 0 : legacyCustomTheme.box) === null || _e === void 0 ? void 0 : _e.text;
        default:
            if (mod === null || mod === void 0 ? void 0 : mod.textColor) {
                return mod.textColor;
            }
            if (mod === null || mod === void 0 ? void 0 : mod.theme) {
                return (_f = creatorLightTheme[mod.theme === 'light' ? 'base' : 'invertedDark']) === null || _f === void 0 ? void 0 : _f.text.base;
            }
            if (mod === null || mod === void 0 ? void 0 : mod.themeName) {
                return (_g = legacyCustomTheme === null || legacyCustomTheme === void 0 ? void 0 : legacyCustomTheme.box) === null || _g === void 0 ? void 0 : _g.text;
            }
            return creatorLightTheme.invertedDark.text.base;
    }
};
export const getModuleAccentColor = (mod) => {
    var _a, _b;
    if ((_a = mod.colors) === null || _a === void 0 ? void 0 : _a.accentColor) {
        return (_b = mod.colors) === null || _b === void 0 ? void 0 : _b.accentColor;
    }
    return getModuleTextColor(mod);
};
